"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = void 0;
var _theme = require("../../../../theme");
var useStyles = (0, _theme.makeStyles)(function () {
  return {
    root: {
      minHeight: 0
    },
    indicator: {
      height: 3
    }
  };
}, {
  name: 'Tabs'
});
exports.useStyles = useStyles;